import { useQuery } from "react-query";
import { useAgentsHttp } from "../useAgentsHttp";
import { QK } from "../queryKeys";
import type { Project } from "../models/project";

// Read one project by project_id via POST /projects/get.

const QUERY_KEY = QK.projectGet;

export const useProject = (project_id?: string) => {
  const http = useAgentsHttp();
  return useQuery<Project | null>(
    [QUERY_KEY, project_id ?? null],
    async () => {
      if (!project_id) return null;
      try {
        return await http<Project>("/projects/get", { project_id });
      } catch (e) {
        // 404 is expected for projects that don't exist yet
        // (the operator might have typed an unknown id manually).
        // Return null rather than throw so the FE renders the
        // blank-form path.
        const err = e as { status?: number };
        if (err.status === 404) return null;
        throw e;
      }
    },
    {
      enabled: Boolean(project_id),
      refetchOnWindowFocus: false,
      staleTime: 60_000,
    },
  );
};
